import { useRequiredContext } from "@lib/utils";
import { ChipFilterNew } from "@molecules";

import { HaNContext } from "../shell/HaNContext";
import { HaNFilterBarContext } from "../shell/regions/HaNFilterBarContext";

export const WorkspacesFilters = () => {
  const { tab } = useRequiredContext(HaNContext);

  if (tab !== "workspaces") return null;

  return <WorkspacesFiltersContent />;
};

const WorkspacesFiltersContent = () => {
  const { areFiltersTransparent } = useRequiredContext(HaNFilterBarContext);

  return (
    <ChipFilterNew
      filterSlice="HereAndNow_Workspaces"
      testIdPrefix="HaNWorkSpaceFilters"
      areFilterTransparent={areFiltersTransparent}
    />
  );
};
